export default function () {
  const widgetName = "tier1MainContentBackground";
  const widgetOpts = tier1MainContentBackgroundOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,
    moreButton: false,
    link: [""],

    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .card-widget-item`).each(function () {
        const { Title, Description, ImageWithPath, ImageAlternateText } =
          data.items[0];

        $(".container-main-feature").css(
          "background-image",
          `url('${ImageWithPath}')`
        );
        $(this).find(".image-container").remove();
        $(this).find(".buttonwrap").remove();

        $(this).find(".card-widget-title").replaceWith(`<h1 class="card-widget-title ee">${Title}</h1>`);
        $(this).find(".card-widget-description").replaceWith(`<h2 class="card-widget-description">${Description}</h2>`);

        $(this).find(".card-content").append(`<span class="last-line">${ImageAlternateText}</span>`);
      });
    },
  });
}
